import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import PublicLayout from "./layout/PublicLayout";
import DashboardLayout from "./layout/productAdminLayout/DashboardLayout";

// Public pages
import AIFeatures from "./pages/AIFeatures/AIFeatures";
import ModulesTools from "./pages/ModulesTools/ModulesTools";
import OurStory from "./pages/OurStory/OurStory";
import BookDemo from "./pages/BookDemo/BookDemo";
import ContactSupport from "./pages/ContactSupport/ContactSupport";
import PlatformFeatures from "./pages/PlatformFeatures/PlatformFeatures";
import WhyIfillip from "./pages/WhyIfillip/WhyIfillip";
import PrivacyPolicy from "./pages/privacypolicy/Privacypolicy";

// Dashboard pages
import DashboardHome from "./pages/dashboard/DashboardHome";
import Profile from "./pages/profile/Profile";
import LicenseList from "./pages/License/LicenseList";
import LicenseCreate from "./pages/License/LicenseCreate";
import UserManagement from "./pages/masters/UserManagement";
import School from "./pages/masters/School";
import SchoolView from "./pages/masters/SchoolView";
import RequestDemo from "./pages/masters/RequestDemo";
import Login from "./pages/Auth/Login";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ChangePassword from "./pages/Auth/ChangePassword";
import Blog from "./pages/blog/Blog";
import BlogView from "./pages/blog/BlogView";
import BlogCreate from "./pages/blog/BlogCreate";
import BlogList from "./pages/blog/BlogList";
import ContactRequest from "./pages/masters/ContactRequest";
import RequestDemoView from "./pages/masters/RequestDemoView";
import RequestContactView from "./pages/masters/RequestContactView";
import AppVersionList from "./pages/appVersion/AppVersionList";
import AppVersionForm from "./pages/appVersion/AppVersionForm";
import AppVersionView from "./pages/appVersion/AppVersionView";
import PlansPricingList from "./pages/masters/plans-pricing/PlansPricingList";
import EditPlansPricing from "./pages/masters/plans-pricing/EditPlansPricing";
import ViewPlansPricing from "./pages/masters/plans-pricing/ViewPlansPricing";
import PreviewPlansPricing from "./pages/masters/plans-pricing/PreviewPlansPricing";
import PlanFeaturesList from "./pages/masters/plan-features/PlanFeaturesList";
import CreatePlanFeature from "./pages/masters/plan-features/CreatePlanFeature";
import AddonConfigList from "./pages/masters/addon-configuration/AddonConfigList";
import CreateAddonConfig from "./pages/masters/addon-configuration/CreateAddonConfig";
import ViewAddonConfig from "./pages/masters/addon-configuration/ViewAddonConfig";
import Home from "./pages/Home/Home";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import usePageTracking from "./hooks/usePageTracking";
import WrongPathRedirect from "./components/wrongpathredirect/WrongPathRedirect";
import SlabConfigList from "./pages/masters/slab-configuration/SlabConfigList";
import CreateSlabConfig from "./pages/masters/slab-configuration/CreateSlabConfig";
import Pricing from "./pages/masters/pricing/Pricing";
import CompareFeatures from "./pages/masters/pricing/CompareFeatures";
import PaymentSuccess from "./pages/masters/pricing/PaymentSuccess";
import PaymentFailed from "./pages/masters/pricing/PaymentFailed";

function App() {
  usePageTracking();
  return (
    <Routes>
      {/* ==================== PUBLIC ROUTES ==================== */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/Why-iFillip" element={<WhyIfillip />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pricing/compare-features" element={<CompareFeatures />} />
        <Route path="/pricing/payment-success" element={<PaymentSuccess />} />
        <Route path="/pricing/payment-failed" element={<PaymentFailed />} />
        <Route path="/ai-suite" element={<AIFeatures />} />
        {/* <Route path="/company" element={<OurStory />} /> */}
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/contact" element={<ContactSupport />} />
        <Route path="/core-features" element={<PlatformFeatures />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogView" element={<BlogView />} />
      </Route>

      {/* ==================== PRODUCT ADMIN ROUTES (Role 1) ==================== */}
      <Route element={<ProtectedRoute allowedRoles={[1]} />}>
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="profile" element={<Profile />} />
          <Route path="license" element={<LicenseList />} />
          <Route path="licenseCreate" element={<LicenseCreate />} />
          <Route path="masters/users" element={<UserManagement />} />
          <Route path="masters/school" element={<School />} />
          <Route path="masters/school/view/:id" element={<SchoolView />} />
          <Route path="masters/request-demo" element={<RequestDemo />} />
          <Route path="blog" element={<BlogList />} />
          <Route path="Blog" element={<BlogList />} />
          <Route path="blogCreate" element={<BlogCreate />} />
          <Route path="appversion" element={<AppVersionList />} />
          <Route path="appversion/create" element={<AppVersionForm />} />
          <Route path="appversion/edit/:id" element={<AppVersionForm />} />
          <Route path="appversion/view/:id" element={<AppVersionView />} />
          <Route path="masters/contact-request" element={<ContactRequest />} />
          <Route path="masters/plans-pricing" element={<PlansPricingList />} />
          <Route
            path="masters/plans-pricing/create"
            element={<EditPlansPricing />}
          />
          <Route
            path="masters/plans-pricing/edit/:id"
            element={<EditPlansPricing />}
          />
          <Route
            path="masters/plans-pricing/view/:id"
            element={<ViewPlansPricing />}
          />
          <Route
            path="masters/plans-pricing/preview/:id"
            element={<PreviewPlansPricing />}
          />
          <Route path="masters/plan-features" element={<PlanFeaturesList />} />
          <Route
            path="masters/plan-features/create"
            element={<CreatePlanFeature />}
          />
          <Route
            path="masters/addon-configuration"
            element={<AddonConfigList />}
          />
          <Route
            path="masters/addon-configuration/create"
            element={<CreateAddonConfig />}
          />
          <Route
            path="masters/addon-configuration/view/:id"
            element={<ViewAddonConfig />}
          />
          <Route
            path="masters/slab-configuration"
            element={<SlabConfigList />}
          />
          <Route
            path="masters/slab-configuration/create"
            element={<CreateSlabConfig />}
          />

          <Route
            path="masters/request-demo/view/:id"
            element={<RequestDemoView />}
          />
          <Route
            path="masters/contact-request/view/:id"
            element={<RequestContactView />}
          />
        </Route>
      </Route>

      {/* ==================== AUTH ROUTES ==================== */}
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/change-password/:email" element={<ChangePassword />} />
      {/* ==================== GLOBAL 404 CATCH-ALL ==================== */}
      {/* Catches all other undefined paths */}
      <Route path="*" element={<WrongPathRedirect />} />
    </Routes>
  );
}

export default App;
